import { DateTime } from "luxon";
import styled from "styled-components";

const ExpireBadge = ({ expireDate }) => {
  expireDate = DateTime.fromISO(expireDate).startOf("day");

  const isExpired = DateTime.fromISO(expireDate) <= DateTime.local();
  const nbDays = Math.ceil(
    DateTime.local().startOf("day").diff(expireDate, "days").toObject().days
  );

  let text = "";
  if (nbDays === 0) {
    text = `Échéance aujourd'hui`;
  } else if (nbDays < 0) {
    text = `Échéance dans ${Math.abs(nbDays)} jours`;
  } else {
    text = `Échu depuis ${nbDays} jours`;
  }

  return (
    <StyledExpireBadge className="font-weight-bold" isExpired={isExpired}>
      {text}
    </StyledExpireBadge>
  );
};

const StyledExpireBadge = styled.div`
  padding: 4px 8px 4px 0px;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
`;

export default ExpireBadge;
